// const files = import.meta.globEager("./modules/*.vue", { eager: false })
// const modules = {}
// for (const key in files) {
//     modules[key.replace(/(\.\/modules\/|\.vue)/g, '')] = files[key].default
// }
// export default {
//     ...modules
// };

const path = require('path')
const files = require.context('./modules/', false, /\.vue$/)

const modules = {}
files.keys().forEach(key => {
    const name = path.basename(key, '.vue')
    modules[name] = files(key).default || files(key)
})
export default modules
